'use strict';

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../core/a11y');

var _stickyHeader = require('../components/stickyHeader');

var _nav = require('../components/nav');

var _cart = require('../components/cart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.jQuery = _jquery2.default;

// Import jQuery
// Import CSS

window.$ = _jquery2.default;

// Vendor


// Core


// Components


document.addEventListener('DOMContentLoaded', function () {
  (0, _stickyHeader.init)();
  (0, _nav.init)();
  (0, _cart.init)();
});

window.addEventListener('load', function () {});